<template>
  <span class="category-chip" :class="{ 'category-chip--white': white }">
    <v-icon size="16" class="category-chip__icon" :class="{ 'category-chip__icon--accent': accent }">
      {{ meta.icon }}
    </v-icon>
    {{ meta.short }}
  </span>
</template>

<script>
  import { category } from './form'

  /** Чип категории обращения: короткое имя и иконка; accent - оранжевая иконка у нового. */
  export default {
    name: 'CategoryChip',
    props: {
      category: { type: String, required: true },
      accent: { type: Boolean, default: false },
      // Белый чип на тёмной плашке специалиста в тикете.
      white: { type: Boolean, default: false },
    },
    computed: {
      meta () {
        return category(this.category)
      },
    },
  }
</script>

<style scoped lang="less">
@import './tokens.less';

.category-chip {
  display: inline-flex;
  flex-shrink: 0;
  gap: 6px;
  align-items: center;
  height: 30px;
  padding: 0 12px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  color: @fakt-text;
  background: @fakt-surface;

  &--white {
    background: @fakt-white;
  }
}

.category-chip__icon {
  color: @fakt-text !important;

  &--accent {
    color: @fakt-orange !important;
  }
}
</style>
